module.exports = __webpack_public_path__ + "img/airline_seat_legroom_reduced.593e58b4.svg";